// extracted by mini-css-extract-plugin
export default {"NavItem":"NavLinkTab_NavItem__HYbnf","ActiveNavItem":"NavLinkTab_ActiveNavItem__xvQiW","Badge":"NavLinkTab_Badge__7uH1N"};